import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "../src/components/ScrollToTop";
import ErrorBoundary from "../src/components/ErrorBoundary";
// Add your imports here
import Login from "../src/pages/login";
import Dashboard from "../src/pages/dashboard";
import InventoryManagement from "../src/pages/inventory-management";
import MasterDataManagement from "../src/pages/master-data-management";
import ProductionWorkflow from "../src/pages/production-workflow";
import InvoiceChallanManagement from "../src/pages/invoice-challan-management";
import NotFound from "../src/pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/inventory-management" element={<InventoryManagement />} />
        <Route path="/master-data-management" element={<MasterDataManagement />} />
        <Route path="/production-workflow" element={<ProductionWorkflow />} />
        <Route path="/invoice-challan-management" element={<InvoiceChallanManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;